import { render } from "./github-connect-ubuntu.vue?vue&type=template&id=9cbae298"
import script from "./github-connect-ubuntu.vue?vue&type=script&lang=js"
export * from "./github-connect-ubuntu.vue?vue&type=script&lang=js"

import "./github-connect-ubuntu.vue?vue&type=style&index=0&id=9cbae298&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__